Ext.define('SA.view.sidebar.location.CreateRadiusLocation', {
    alias: 'widget.create-radius-location',
    extend: 'Ext.Container',

    cls: 'sa-create-radius',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',
    width: 460,

    layout: {
        type: 'vbox',
        align: 'stretch'
    },

    initComponent() {
        var censusRelease = SA.AppController.getCurrentModelCensusRelease(),
            discoverableUnits = SA.AppController.getCurrentProject().getDiscoverableGeographicUnits(),
            searchUnits = discoverableUnits.filter(unit => SA.data.GeographicUnits.get(unit).maximumRadius > 0);

        this.items = [
            {
                xtype: 'container',

                items: [
                    {
                        xtype: 'close-button'
                    }, {
                        xtype: 'component',
                        cls: 'sa-create-radius-heading',

                        renderTpl: [
                            '<div class="sa-create-radius-title">',
                                'Create Radius Location',
                            '</div>',
                            '<div class="sa-create-radius-instructions">',
                                '{[SA.localize("What location is at the center of your radius?")]}',
                            '</div>'
                        ]
                    }
                ],

                layout: {
                    type: 'auto'
                }
            }, {
                xtype: 'container',
                margin: '0 40',

                layout: {
                    type: 'vbox',
                    align: 'stretch'
                },

                items: [
                    {
                        allowCustomLocations: false,
                        allowRecentListCustomLocationMenuItems: false,
                        geographicUnits: searchUnits,
                        xtype: 'location-search-field',

                        listeners: {
                            select(field, locationSeries) {
                                this.up('create-radius-location').setLocation(locationSeries);

                                this.getRecentList().hide();
                            }
                        },

                        xhooks: {
                            beforeRender() {
                                this.getRecentList().checkMarkTooltip = 'Currently selected location';

                                this.callParent();
                            }
                        }
                    }, {
                        xtype: 'component',
                        cls: 'sa-create-radius-label',
                        html: 'Selected Location:',
                        margin: '3 0'
                    }, {
                        xtype: 'component',
                        cls: 'sa-create-radius-selected-location',
                        data: {location: {name: '\u00a0'}},
                        itemId: 'selectedLocation',
                        margin: '0 0 15',
                        tpl: '{location:locationRenderer}',

                        refresh() {
                            this.update({location: SA.data.LocationsCache.get(this.locationSeries)});
                        }
                    }, {
                        fieldLabel: 'Radius',
                        labelWidth: 65,
                        margin: '0 0 15',
                        xtype: 'fieldcontainer',

                        items: [
                            {
                                allowBlank: false,
                                autoStripChars: true,
                                itemId: 'radius',
                                margin: '0 14 0 0',
                                maxLength: 10,
                                minValue: 1,
                                value: 1,
                                width: 71,
                                xtype: 'sa-numberfield',

                                listeners: {
                                    validitychange(field, isValid) {
                                        var win = this.up('create-radius-location'),
                                            selectedLocationField = win.down('#selectedLocation'),
                                            doneBtn = win.down('#doneBtn'),
                                            isValidLocationSeries = 'locationSeries' in selectedLocationField;

                                        doneBtn.setEnabled(isValid && isValidLocationSeries);
                                    }
                                }
                            }, {
                                flex: 1,
                                height: 57,
                                itemId: 'unit',
                                textField: 1,
                                value: SA.AppController.getCurrentCountry().isUSA() ? 'miles' : 'km',
                                valueField: 0,
                                xtype: 'combo-button',

                                items: [
                                    ['miles', 'miles'],
                                    ['km', SA.localize('kilometers')],
                                    ['feet', 'feet'],
                                    ['m', SA.localize('meters')]
                                ]
                            }
                        ],

                        layout: {
                            align: 'middle',
                            type: 'hbox'
                        }
                    }, {
                        xtype: 'simple-container',
                        cls: 'sa-create-radius-name-ct',

                        items: [
                            {
                                xtype: 'component',
                                cls: 'sa-create-radius-label',
                                html: 'Location name (optional):'
                            }, {
                                xtype: 'sa-text-field',
                                cls: 'sa-create-radius-name-field',
                                itemId: 'name'
                            }
                        ]
                    }
                ]
            }, {
                xtype: 'container',
                cls: 'sa-create-radius-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        disabled: true,
                        itemId: 'doneBtn',
                        text: 'Save',
                        ui: 'primary',
                        width: 118,

                        handler() {
                            var btn = this,
                                win = btn.up('create-radius-location'),
                                locationSeries = win.selectedLocationField.locationSeries,
                                location = SA.data.LocationsCache.get(locationSeries),
                                radius = win.down('#radius').getValue() || 1,
                                unit = win.down('#unit').getValue(),
                                name = win.down('#name').getValue() || 'Within ' + radius + unit + ' of ' + location.name,
                                country = SA.AppController.getCurrentCountryCode(),
                                smallestGeographicUnit = SA.data.GeographicUnits.smallestIdFor(country);

                            if (radius > maximumRadius(unit)) {
                                Ext.widget({
                                    xtype: 'alert',
                                    message: `Please enter a radius less than or equal to ${prettyMaximumRadiusAndUnit(unit)}.`,
                                    title: 'Maximum Radius Exceeded'
                                });

                                return;
                            }

                            btn.disable();
                            win.setLoading('Saving…');

                            SA.Ajax.request({
                                method: 'create',
                                resource: 'user/customLocations',

                                data: [{
                                    geographicUnit: smallestGeographicUnit,
                                    locationSeries,
                                    name,
                                    radius,
                                    type: 'radius',
                                    unit
                                }],

                                success(locations) {
                                    var radiusLocation = locations[0];

                                    SA.data.CustomLocations.add(radiusLocation);

                                    Ext.callback(win.callback, win.scope, [radiusLocation]);

                                    win.destroy();
                                }
                            });

                            function maximumRadius(unit) {
                                var maxKms = 350,
                                    maxMiles = 250;

                                return {
                                    feet: maxMiles * 5280,
                                    km: maxKms,
                                    m: maxKms * 1000,
                                    miles: maxMiles
                                }[unit];
                            }

                            function prettyMaximumRadiusAndUnit(unit) {
                                var maxRadius, unitName;

                                switch (unit) {
                                    case 'feet':
                                    case 'miles':
                                        maxRadius = maximumRadius('miles');
                                        unitName = 'miles';
                                    break;

                                    case 'km':
                                    case 'm':
                                        maxRadius = maximumRadius('km');
                                        unitName = SA.localize('kilometers');
                                    break;
                                }

                                return `${maxRadius} ${unitName}`;
                            }
                        }
                    }, {
                        xtype: 'sa-button',
                        text: 'Cancel',
                        width: 118,

                        handler() {
                            this.up('create-radius-location').destroy();
                        }
                    }
                ],

                layout: {
                    type: 'hbox',
                    pack: 'center'
                }
            }
        ];

        this.callParent();

        this.searchField = this.down('location-search-field');
        this.doneBtn = this.down('#doneBtn');
        this.selectedLocationField = this.down('#selectedLocation');
        this.radiusField = this.down('#radius');

        this.searchField.setCensusRelease(censusRelease);

        SA.LocationsReferenceTracker.registerReferencer(this);
    },

    beforeDestroy() {
        SA.LocationsReferenceTracker.unregisterReferencer(this);

        this.callParent();
    },

    getReferencedLocations() {
        return Ext.Array.from(this.selectedLocationField.locationSeries);
    },

    setLocation(locationSeries) {
        var selectedLocation = this.selectedLocationField;

        selectedLocation.locationSeries = locationSeries;
        selectedLocation.refresh();

        this.searchField.setSelected([locationSeries]);

        if (this.radiusField.isValid()) {
            this.doneBtn.enable();
        }
    }
});
